import { useState, useCallback, useEffect } from "react";
import { useCspApi } from "@perfectserve/http-ps";
export const useNetworkErrorsData = () => {
    const { get } = useCspApi();
    const [dateRange, setDateRange] = useState(() => {
        const now = new Date();
        const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
        return {
            startDate: yesterday.toISOString(),
            endDate: now.toISOString(),
            preset: "1d",
        };
    });
    const [allInteractions, setAllInteractions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [availableActions, setAvailableActions] = useState([]);
    const [selectedActions, setSelectedActions] = useState(["Error"]);
    const fetchErrorData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const startDate = new Date(dateRange.startDate);
            const endDate = new Date(dateRange.endDate);
            const startDateFormatted = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 4, 0, 0).toISOString();
            const endDateFormatted = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1, 3, 59, 59, 999).toISOString();
            const dateFilter = `(InteractionStartDateUtc ge ${startDateFormatted} and InteractionStartDateUtc le ${endDateFormatted})`;
            const timeFilter = `(time(InteractionStartDateUtc) ge 00:00:00.00000 and time(InteractionStartDateUtc) le 23:59:00.00000)`;
            const actionsToFetch = selectedActions.length > 0 ? selectedActions : ["Error"];
            const actionFilter = actionsToFetch.length === 1
                ? `(InteractionFinalAction eq '${actionsToFetch[0]}')`
                : `(${actionsToFetch.map((action) => `InteractionFinalAction eq '${action}'`).join(" or ")})`;
            const filter = `${dateFilter} and ${timeFilter} and ${actionFilter}`;
            const encodedFilter = encodeURIComponent(filter);
            const url = `/api/reporting/interactions?$filter=${encodedFilter}&$orderby=InteractionStartDateUtc desc&$top=50000`;
            const response = await get(url);
            const data = response.data;
            setAllInteractions(data);
            const commonActions = [
                "Error",
                "Patient",
                "Provider",
                "Disconnect",
                "HandoffTransfer",
                "Hangup",
                "VoiceMessage",
                "Email",
                "Cancel",
            ];
            setAvailableActions(commonActions);
        }
        catch (err) {
            console.error("Failed to fetch error data:", err);
            setError(err instanceof Error ? err.message : "Failed to fetch error data");
        }
        finally {
            setLoading(false);
        }
    }, [dateRange, selectedActions, get]);
    useEffect(() => {
        fetchErrorData();
    }, [fetchErrorData]);
    const handleDateRangeChange = (newDateRange) => {
        setDateRange(newDateRange);
    };
    return {
        dateRange,
        allInteractions,
        loading,
        error,
        availableActions,
        selectedActions,
        setSelectedActions,
        handleDateRangeChange,
        fetchErrorData,
    };
};
//# sourceMappingURL=useNetworkErrorsData.js.map